import { DefaultService } from '@/services/DefaultService';

export default class PrazoPagtoService extends DefaultService {
	constructor(http, router, env) {
		super(http, router, env);
	}

    findAllCombo(limit = 100, ...params){
        return this._http.get(`${this._env}/vendas/prazo-pagamento/findallcombo.json?limit=${limit}&param=${params}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

	findAllHasOrder(column = 'datahorainc', order = 'desc', page = 0, limit = 50, ...params) {
		return this._http.get(encodeURI(`${this._env}/paiementterme/order/all.json?page=${page}&limit=${limit}&column=${column}&order=${order}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

	findAll(column, order, page, limit, situacao, ...params) {
		return this._http.get(encodeURI(`${this._env}/vendas/prazo-pagamento.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`), this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	updateSituacao(prazopagamento) {
		return this._http.post(`${this._env}/vendas/prazo-pagamento/updatesituacao`, prazopagamento, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}
	save(form) {
		return this._http.post(`${this._env}/vendas/prazo-pagamento`, form, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}


	find(id) {
		return this._http.get(`${this._env}/vendas/prazo-pagamento/${id}.json`, this._headers).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw new Error('Problems while jobs are loading');
		});
	}

	findNaoAssociadosVendas(column, order, page, limit, idempresa, ...params) {
		return this._http.get( encodeURI(`${this._env}/vendas/prazo-pagamento/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&param=${params}`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

    findNaoAssociadosAgro(column, order, page, limit, idempresa, ...params) {
		return this._http.get( encodeURI(`${this._env}/agro/prazo-pagamento/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idempresa=${idempresa}&param=${params}`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}
}